import script from "./ContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactCard.vue?vue&type=script&setup=true&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=8ce58a3e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce58a3e"]])

export default __exports__